import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTmuxComponent } from './simple-icons-tmux.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTmuxComponent ],
    exports:      [ SimpleIconsTmuxComponent ],
    bootstrap:    []
})
export class SimpleIconsTmuxModule {}
